<template>
  <div style="margin: 0 24px 12px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="门店零售价：">
        <el-input v-model="price" placeholder="请输入门店零售价" :disabled="stockForm.shopRetailEdit == 0"/>
      </el-form-item>
      <el-form-item label="预警库存量：">
        <el-input v-model="num" placeholder="请输入预警库存量" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateShopCommodity} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      type: this.value.type,
      stockForm: this.value.stockForm,

      num: this.value.stockForm.stockWarnNum,
      price: this.value.stockForm.shopRetailPrice,

    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      // if(!this.num) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请输入预警库存量',
      //     type: 'warning'
      //   });
      //   return false
      // }
      // if(!this.price) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请输入门店零售价',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let param = {}
      param['id'] = this.stockForm.id
      param['stockWarnNum'] = this.num
      param['shopRetailPrice'] = this.price
      postFormData(updateShopCommodity, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
